(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ── 1. LENIS SMOOTH SCROLL ──────────────────────────────────────────────
  function initLenis() {
    if (REDUCED || typeof Lenis === 'undefined') return;

    var lenis = new Lenis({
      duration: 1.2,
      easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
      smoothWheel: true,
      wheelMultiplier: 1,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    window.tanehraLenis = lenis;
  }

  // ── 2. SCROLL REVEAL ───────────────────────────────────────────────────
  function initScrollReveal() {
    if (REDUCED) return;

    var targets = [
      '.card-wrapper',
      '.t-contact__heading',
      '.t-contact__intro',
      '.t-contact__detail',
      '.t-contact__response',
      '.t-contact__form-panel',
      '.collection-hero .collection__title',
      '.featured-collection .title',
    ];

    targets.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (el.closest('.scroll-trigger') || el.classList.contains('t-reveal')) return;
        el.classList.add('t-reveal');

        if (el.classList.contains('card-wrapper')) {
          var siblings = Array.from(
            el.parentElement
              ? el.parentElement.querySelectorAll(':scope > .card-wrapper')
              : []
          );
          var idx = siblings.indexOf(el);
          el.style.setProperty('--t-reveal-delay', (idx % 4) * 0.08 + 's');
        }
      });
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });

    document.querySelectorAll('.t-reveal').forEach(function (el) {
      observer.observe(el);
    });
  }

  // ── 4. PRODUCT CARD VIEW OVERLAY ───────────────────────────────────────
  function initCardHover() {
    document.querySelectorAll('.card__media').forEach(function (media) {
      if (media.querySelector('.t-card-view')) return;
      var el = document.createElement('div');
      el.className = 't-card-view';
      el.textContent = 'View';
      media.appendChild(el);
    });
  }

  // ── 5. HERO TEXT SPLIT ─────────────────────────────────────────────────
  function initHeroReveal() {
    if (REDUCED) return;
    var isHome = document.body.classList.contains('template-index') ||
                 window.location.pathname === '/';
    if (!isHome) return;

    var heading = document.querySelector(
      '.banner__heading h1, .banner__heading h2, .banner h1, .banner h2'
    );
    if (!heading || heading.querySelector('.t-word')) return;

    var raw = heading.textContent.trim();
    if (!raw) return;

    var words = raw.split(/\s+/).filter(Boolean);
    heading.textContent = '';

    words.forEach(function (word, i) {
      var outer = document.createElement('span');
      outer.className = 't-word';
      var inner = document.createElement('span');
      inner.className = 't-word__inner';
      inner.style.setProperty('--word-i', i);
      inner.textContent = word;
      outer.appendChild(inner);
      heading.appendChild(outer);
      if (i < words.length - 1) heading.appendChild(document.createTextNode(' '));
    });

    var sr = document.createElement('span');
    sr.className = 'visually-hidden';
    sr.textContent = raw;
    heading.appendChild(sr);

    setTimeout(function () {
      heading.classList.add('t-words-revealed');
    }, 680);
  }

  // ── 6. CUSTOM SORT DROPDOWN ────────────────────────────────────────────
  function buildSortDropdown(nativeSelect) {
    var selectWrap = nativeSelect.closest('.select');
    if (!selectWrap || selectWrap.querySelector('.t-sort-wrap')) return;

    nativeSelect.style.cssText = 'position:absolute;opacity:0;pointer-events:none;width:1px;height:1px;';
    var dawnSvg = selectWrap.querySelector('svg');
    if (dawnSvg) dawnSvg.style.display = 'none';

    var selected = nativeSelect.options[nativeSelect.selectedIndex];

    var wrap = document.createElement('div');
    wrap.className = 't-sort-wrap';

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 't-sort-trigger';
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-haspopup', 'listbox');

    var valSpan = document.createElement('span');
    valSpan.className = 't-sort-value';
    valSpan.textContent = selected ? selected.text : '';
    trigger.appendChild(valSpan);

    var chev = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    chev.setAttribute('viewBox', '0 0 10 6');
    chev.setAttribute('width', '10');
    chev.setAttribute('height', '6');
    chev.setAttribute('aria-hidden', 'true');
    chev.setAttribute('class', 't-sort-chev');
    var poly = document.createElementNS('http://www.w3.org/2000/svg', 'polyline');
    poly.setAttribute('points', '1 1 5 5 9 1');
    poly.setAttribute('fill', 'none');
    poly.setAttribute('stroke', 'currentColor');
    poly.setAttribute('stroke-width', '1.5');
    poly.setAttribute('stroke-linecap', 'round');
    poly.setAttribute('stroke-linejoin', 'round');
    chev.appendChild(poly);
    trigger.appendChild(chev);

    var panel = document.createElement('ul');
    panel.className = 't-sort-panel';
    panel.setAttribute('role', 'listbox');

    Array.from(nativeSelect.options).forEach(function (opt) {
      var item = document.createElement('li');
      item.className = 't-sort-item' + (opt.selected ? ' is-selected' : '');
      item.setAttribute('role', 'option');
      item.setAttribute('data-value', opt.value);
      item.setAttribute('aria-selected', String(opt.selected));
      item.textContent = opt.text;

      item.addEventListener('click', function () {
        nativeSelect.value = opt.value;
        nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
        nativeSelect.dispatchEvent(new Event('input', { bubbles: true }));
        valSpan.textContent = opt.text;
        panel.querySelectorAll('.t-sort-item').forEach(function (el) {
          el.classList.remove('is-selected');
          el.setAttribute('aria-selected', 'false');
        });
        item.classList.add('is-selected');
        item.setAttribute('aria-selected', 'true');
        panel.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.classList.remove('is-open');
      });

      panel.appendChild(item);
    });

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = panel.classList.contains('is-open');
      document.querySelectorAll('.t-sort-panel.is-open').forEach(function (p) {
        p.classList.remove('is-open');
        if (p.previousElementSibling) {
          p.previousElementSibling.setAttribute('aria-expanded', 'false');
          p.previousElementSibling.classList.remove('is-open');
        }
      });
      if (!open) {
        panel.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        trigger.classList.add('is-open');
      }
    });

    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) {
        panel.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.classList.remove('is-open');
      }
    });

    wrap.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        panel.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.classList.remove('is-open');
        trigger.focus();
      }
    });

    wrap.appendChild(trigger);
    wrap.appendChild(panel);
    selectWrap.appendChild(wrap);
  }

  function initSortDropdown() {
    var existing = document.querySelectorAll('.facet-filters__sort.select__select');
    existing.forEach(buildSortDropdown);

    // facet-filters-form is a custom element that renders AFTER DOMContentLoaded.
    // MutationObserver catches the select when it appears.
    var obs = new MutationObserver(function () {
      var selects = document.querySelectorAll('.facet-filters__sort.select__select');
      selects.forEach(function (sel) {
        var wrap = sel.closest('.select');
        if (wrap && !wrap.querySelector('.t-sort-wrap')) buildSortDropdown(sel);
      });
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  // ── 7. FACET CLOSE ANIMATION ──────────────────────────────────────────
  function initFacetCloseAnim() {
    function attachToDetails(details) {
      if (details._tFacetBound) return;
      details._tFacetBound = true;
      var summary = details.querySelector('.facets__summary');
      if (!summary) return;
      summary.addEventListener('click', function (e) {
        if (!details.open) return; // opening — let browser handle normally
        e.preventDefault();
        var panel = details.querySelector('.facets__display');
        if (!panel) { details.removeAttribute('open'); return; }
        panel.classList.add('is-closing');
        panel.addEventListener('animationend', function handler() {
          panel.removeEventListener('animationend', handler);
          panel.classList.remove('is-closing');
          details.removeAttribute('open');
        }, { once: true });
      });
    }

    document.querySelectorAll('.facets__disclosure').forEach(attachToDetails);

    // Catch any facets rendered after DOMContentLoaded (e.g. after filtering)
    new MutationObserver(function () {
      document.querySelectorAll('.facets__disclosure').forEach(attachToDetails);
    }).observe(document.body, { childList: true, subtree: true });
  }

  // ── INIT ───────────────────────────────────────────────────────────────
  function init() {
    initLenis();
    initScrollReveal();
    initCardHover();
    initHeroReveal();
    initSortDropdown();
    initFacetCloseAnim();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
